import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Adds a hover lift effect — use when the card is clickable. */
  interactive?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(({ interactive, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-kw-lg border border-kw-border bg-white shadow-kw-xs',
        interactive && 'cursor-pointer transition-shadow hover:shadow-kw-md',
        className,
      )}
      {...props}
    />
  );
});
Card.displayName = 'Card';
